import { Avatar } from '@mui/material';

const Logo = (props) => (
  <Avatar
    alt="Logo"
    src="https://rayo.s3.us-west-1.amazonaws.com/rayoHorizontal_c.png"
    {...props}
    style={{ width: 84, height: 63 }}
  />
);

export default Logo;
